import styled from 'styled-components'

interface CheckboxListProps {
    column?: boolean
}

export const CheckboxList = styled.div<CheckboxListProps>`
    display: flex;
    flex-direction: ${(props) => (props?.column ? 'column' : 'row')};
    gap: ${(props) => (props?.column ? '8px' : '24px')};
`
